import { Controller } from "@hotwired/stimulus"

// Hides/shows a side panel and swaps the layout classes on its wrapper.
//   data-toggle-target-value  -> id of the element to hide/show
//   data-toggle-layout-value  -> id of the grid wrapper
//   data-toggle-split-class-value / data-toggle-wide-class-value -> classes swapped on the wrapper
//   data-toggle-show-label-value / data-toggle-hide-label-value -> button text
export default class extends Controller {
  static values = {
    target: String,
    layout: String,
    splitClass: { type: String, default: "" },
    wideClass: { type: String, default: "" },
    showLabel: { type: String, default: "Show panel" },
    hideLabel: { type: String, default: "Hide panel" }
  }

  toggle(event) {
    event.preventDefault()
    const panel = document.getElementById(this.targetValue)
    if (!panel) return
    const hidden = panel.classList.toggle("hidden")
    const layout = this.layoutValue ? document.getElementById(this.layoutValue) : null
    const split = this.splitClassValue.split(" ").filter(Boolean)
    const wide = this.wideClassValue.split(" ").filter(Boolean)
    if (layout) {
      if (hidden) { layout.classList.remove(...split); layout.classList.add(...wide) }
      else { layout.classList.remove(...wide); layout.classList.add(...split) }
    }
    this.element.textContent = hidden ? this.showLabelValue : this.hideLabelValue
    this.element.setAttribute("aria-expanded", hidden ? "false" : "true")
  }
}
